import React, { useState } from 'react';
import { IoSearch } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const SearchBar = ({ categories }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if(searchTerm) {
      navigate(`/pesquisa/${searchTerm}`, { state: { searchTerm } });
    }
    setSearchTerm('');
  };

  return (
    <form onSubmit={handleSearch} className="relative flex items-center w-full max-w-md">
      <input
        className="w-full lg:min-w-96  px-3 py-2 border-b rounded focus:outline-none"
        type="text"
        placeholder="O que procura..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <button
        type="submit"
        className="absolute inset-y-0 right-0 flex items-center justify-center text-white rounded-r px-2 py-2 focus:outline-none"
      >
        <IoSearch className="w-5 h-5 text-customPurple" />
      </button>
    </form>
  );
};

export default SearchBar;
